import Request from './request'

const DeviceTariffication = {

  getCompanyTariffDevices(params, callback) {
    Request.get('device-tariffication/tariff-devices', params).then(callback).catch(this.bad_answer)
  },
  getTariffDeviceInfo(id, callback) {
    Request.post('device-tariffication/tariff-device-info/' + id).then(callback).catch(this.bad_answer)
  },
  addDeviceTariff(params, callback) {
    Request.post('device-tariffication/add-device-tariff', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  stopDeviceTariff(params, callback) {
    Request.post('device-tariffication/stop-device-tariff', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  updateDeviceTariff(id, params, callback) {
    Request.post('device-tariffication/update-device-tariff/' + id, JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  statsTariffDevices(params, callback) {
    Request.post('device-tariffication/stats-tariff-devices', JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getDeviceAvailableTariffs(id, callback) {
    Request.get('device-tariffication/get-device-available-tariffs/' + id).then(callback).catch(this.bad_answer)
  },
  getDeviceTarifficationPackets(dev_id, callback) {
    Request.get('device-tariffication/device-tariffication-packets/' + dev_id).then(callback).catch(this.bad_answer)
  },
  buyTrafficPacket(params, callback) {
    Request.post('device-tariffication/buy-traffic-packet' , JSON.stringify(params)).then(callback).catch(this.bad_answer)
  },
  getAvailableTrafficPackets(tariffication_id, callback) {
    Request.get('device-tariffication/available-traffic-packets/' + tariffication_id).then(callback).catch(this.bad_answer)
  },
  stopDeviceTariffication(params, callback) {
    Request.post('device-tariffication/stop-device-tariffication' , JSON.stringify(params)).then(callback).catch(this.bad_answer)
  }
}

export default DeviceTariffication
